import React, { Fragment } from "react";
import { withTheme, withStyles } from "@material-ui/core/styles";
import { injectIntl } from "react-intl";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Grid, Typography, IconButton, TextField, Button, Box, Paper } from "@material-ui/core";

import { withHistory, formatMessage, PublishedComponent, FormPanel } from "@openimis/fe-core";
import { withModulesManager, formatDateFromISO } from "@openimis/fe-core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const styles = (theme) => ({
  tableTitle: theme.table.title,
  page: theme.page,
  paper: theme.paper.paper,
  item: theme.paper.item,
  title: theme.paper.title,
  fullHeight: {
    height: "100%",
  },
  backButton: {
    marginRight: theme.spacing(1),
    color: "#006273",
  },
  titleBar: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1, 2),
    backgroundColor: "#b7d4d8",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
});

class QualityAssuranceProjectMasterPanel extends FormPanel {
  constructor(props) {
    super(props);
  }

  goBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { classes, updateAttribute, readOnly = false, edited, projectUuid, type } = this.props;

    return (
      <Fragment>
        <Paper className={classes.paper}>
          <div className={classes.titleBar}>
            <IconButton className={classes.backButton} onClick={this.goBack} aria-label="back" size="small">
              <ArrowBackIosIcon fontSize="medium" />
            </IconButton>
            <Typography className={classes.title}>
              {projectUuid ? "Quality Assurrance Details" : "Add Quality Assurance"}
            </Typography>
          </div>
          <div className={classes.page}>
            <Grid container spacing={2}>
              {edited && edited?.name && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Quality Assurance Name"
                    value={edited.name}
                    disabled={edited}
                    onChange={(e) => updateAttribute("projectName", e.target.value)}
                  />
                </Grid>
              )}
              <Grid item xs={4}>
                <PublishedComponent
                  pubRef="location.HealthFacilityPicker"
                  value={edited?.healthFacility ?? null}
                  readOnly={projectUuid}
                  onChange={(hf) => updateAttribute("healthFacility", hf)}
                  ignoreLocation={true}
                />
              </Grid>

              {projectUuid && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    disabled={projectUuid}
                    value={
                      !!edited
                        ? formatMessage(this.props.intl, "quality_assurance_and_accreditation", `quality_assurance_and_accreditation.status.${edited?.status}`)
                        : ""
                    }
                    label="Status"
                  />
                </Grid>
              )}

              {projectUuid && (
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    value={
                      !!edited ? formatDateFromISO(this.props.modulesManager, this.props.intl, edited?.createdDate) : ""
                    }
                    label="Date Created"
                    disabled={edited}
                  />
                </Grid>
              )}
            </Grid>{" "}
            <Box display="flex" justifyContent="end" sx={{ m: 2 }}>
              {!projectUuid && (
                <Button variant="contained" color="primary" onClick={this.props.createProject}>
                  Save
                </Button>
              )}
            </Box>
          </div>
        </Paper>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("Redux State", state);
  return {
    rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
    mutation: state.quality_assurance_and_accreditation.mutation,
    submittingMutation: state.quality_assurance_and_accreditation.submittingMutation,
    validatedForms: state.quality_assurance_and_accreditation.validatedForms || [],
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withModulesManager(
  injectIntl(
    withTheme(
      withStyles(styles)(withHistory(connect(mapStateToProps, mapDispatchToProps)(QualityAssuranceProjectMasterPanel))),
    ),
  ),
);
